import axios from "axios";
import React, { useState, useEffect } from "react";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { Tooltip } from "antd";
import { baseUrl } from "../../Axios";
import { useSelector } from "react-redux";
import "./Coupons.scss";
import PaginationComponent from "../../utilities/Pagination";
import { useNavigate } from "react-router";
import CouponPopup from "./CouponPopup/CouponPopup";
import tenKforForty from "../../assets/CouponTemplate/10kfor40_-_dashboard.jpg";
import thirtyOnePlan from "../../assets/CouponTemplate/30one_-_dashboard.jpg";
import thirtySixPlan from "../../assets/CouponTemplate/30six_-_dashboard.jpg";
import twentyFiveOne from "../../assets/CouponTemplate/25one_-_dashboard.png";
import alphaFifteen from "../../assets/CouponTemplate/alpha15_-_dashboard.jpg";
import ondemand_ from "../../assets/CouponTemplate/ondemand_-_dashboard.jpg";

const Coupons = () => {
  const [coupons, setCoupons] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [copiedCoupon, setCopiedCoupon] = useState(null);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const { ACCtoken } = useSelector((state) => state);
  const navigate = useNavigate();

  const fetchCouponList = async (page = 1, pageSize = 10) => {
    setLoading(true);
    setError(null);

    const config = {
      headers: { Authorization: `Bearer ${ACCtoken}` },
      params: { page, page_size: pageSize },
    };

    try {
      const response = await axios.get(`${baseUrl}/published-coupons/`, config);
      setCoupons(response.data.results || []);
      setTotalPages(Math.ceil((response.data.count || 0) / pageSize));
    } catch (error) {
      console.error("Error fetching coupons:", error);
      setError("Failed to fetch coupons");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCouponList(page, pageSize);
    // eslint-disable-next-line
  }, [page, pageSize]);
  const getCouponBackgroundImage = (name) => {
    switch (name.toLowerCase()) {
      case "10kfor40":
        return tenKforForty;
      case "30one":
        return thirtyOnePlan;
      case "30six":
        return thirtySixPlan;
      case "25one":
        return twentyFiveOne;
      case "alpha15":
        return alphaFifteen;
      case "ondemand":
        return ondemand_;
      default:
        return null;
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  };

  const formatTime = (timeString) => {
    return timeString ? timeString.slice(0, 5) : "";
  };

  const getDiscountText = (coupon) => {
    if (coupon.coupon_percent > 0) {
      return `${coupon.coupon_percent}% OFF`;
    } else if (coupon.coupon_amount && parseFloat(coupon.coupon_amount) > 0) {
      return `$${coupon.coupon_amount} OFF`;
    }
    return "Special Offer";
  };

  const isExpired = (expiryDate, expiryTime) => {
    const now = new Date();
    const expiry = new Date(`${expiryDate}T${expiryTime}`);
    return now > expiry;
  };

  const isActive = (startDate, startTime, expiryDate, expiryTime) => {
    const now = new Date();
    const start = new Date(`${startDate}T${startTime}`);
    const expiry = new Date(`${expiryDate}T${expiryTime}`);
    return now >= start && now <= expiry;
  };

  const handleCopy = (couponIndex) => {
    setCopiedCoupon(couponIndex);
    setTimeout(() => {
      setCopiedCoupon(null);
    }, 2000);
  };

  // Tooltip content for challenges
  const getChallengesTooltip = (challenges) => (
    <div className="tooltip-content">
      <ul>
        {challenges.map((challenge, idx) => (
          <li key={idx}>
            <strong>{challenge.name}</strong>
            <span className="tooltip-steps"> - {challenge.steps} steps</span>
          </li>
        ))}
      </ul>
    </div>
  );

  if (loading) {
    return (
      <div className="coupons-container">
        <div className="loading">Loading coupons...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="coupons-container">
        <div className="error">Error: {error}</div>
      </div>
    );
  }

  return (
    <div className="PageContainer coupons-container">
      {/* <CouponPopup /> */}
      {coupons.length === 0 ? (
        <div className="no-coupons">
          <div className="empty-state">
            <div className="empty-icon">🎫</div>
            <h3>No Coupons Available</h3>
            <p>Check back later for new special offers!</p>
          </div>
        </div>
      ) : (
        <div className="coupons-content">
          {coupons.map((coupon, index) => {
            const expired = isExpired(coupon.coupon_expiry, coupon.expiry_time);
            const active = isActive(
              coupon.start_date,
              coupon.start_time,
              coupon.coupon_expiry,
              coupon.expiry_time
            );
            const isCopied = copiedCoupon === index;
            const backgroundImage = getCouponBackgroundImage(
              coupon.coupon_name
            );
            return (
              <div
                key={index}
                className={`coupon-card ${expired ? "expired" : ""}`}
              >
                <div
                  className="coupon-header"
                  style={{
                    backgroundImage: backgroundImage
                      ? `url(${backgroundImage})`
                      : "none",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    borderRadius: "12px 12px 0 0",
                  }}
                >
                  <div className="badges">
                    {active && <div className="active-badge">ACTIVE</div>}
                    {!active && expired && (
                      <div className="expired-badge">EXPIRED</div>
                    )}
                    <div className="coupon-badge">
                      {getDiscountText(coupon)}
                    </div>
                  </div>
                  <div className="coupon-title-section">
                    <div className="coupon-code-container">
                      <h2 className="coupon-name">{coupon.coupon_name}</h2>
                      <CopyToClipboard
                        text={coupon.coupon_name}
                        onCopy={() => handleCopy(index)}
                      >
                        <button
                          className={`copy-button ${isCopied ? "copied" : ""}`}
                          title="Copy coupon code"
                        >
                          {isCopied ? (
                            <>
                              <span className="copy-icon">✓</span>
                              <span className="copy-text">Copied!</span>
                            </>
                          ) : (
                            <>
                              <span className="copy-icon">📋</span>
                              <span className="copy-text">Copy</span>
                            </>
                          )}
                        </button>
                      </CopyToClipboard>
                    </div>
                  </div>
                </div>

                <div className="coupon-body">
                  <div className="coupon-info-section">
                    <div className="info-row">
                      {/* <div className="info-item">
                        <span className="info-label">Start Date</span>
                        <span className="info-value">
                          {formatDate(coupon.start_date)}{" "}
                          {formatTime(coupon.start_time)}
                        </span>
                      </div> */}
                      <div className="info-item">
                        <span className="info-label">Expiry Date</span>
                        <span className="info-value">
                          {formatDate(coupon.coupon_expiry)}{" "}
                          {formatTime(coupon.expiry_time)}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="coupon-challenges-section">
                    {coupon.challenges.length ? (
                      <Tooltip
                        title={getChallengesTooltip(coupon.challenges)}
                        color="#222"
                        overlayClassName="ant-custom-tooltip"
                        placement="bottomLeft"
                        mouseEnterDelay={0.1}
                        mouseLeaveDelay={0.1}
                      >
                        <div
                          className="challenges-header"
                          tabIndex={0}
                          role="button"
                          aria-label="Show applicable challenges"
                        >
                          <h3 className="section-title">
                            Applicable Challenges ({coupon.challenges.length})
                          </h3>
                          <span className="tooltip-icon"></span>
                        </div>
                      </Tooltip>
                    ) : (
                      <div
                        className="challenges-header disabled"
                        tabIndex={0}
                        role="button"
                        aria-label="No applicable challenges"
                      >
                        <h3 className="section-title">
                          Applicable Challenges (All)
                        </h3>
                        <span className="tooltip-icon"></span>
                      </div>
                    )}
                  </div>

                  {coupon.description && (
                    <div className="coupon-description-section">
                      <h3 className="section-title">Description</h3>
                      <p className="description-text">{coupon.description}</p>
                    </div>
                  )}
                  {/* <button
                    onClick={() =>
                      navigate(
                        `/FundingEvaluationPayments/${
                          (coupon.challenges?.length &&
                            coupon.challenges[0]?.id) ||
                          89
                        }/${encodeURIComponent(coupon.coupon_name)}`
                      )
                    }
                    className="purchase-challenge-button"
                  >
                    Purchase Challenge
                  </button> */}
                </div>
              </div>
            );
          })}
        </div>
      )}
      {coupons.length && (
        <div
          style={{ marginTop: 32, display: "flex", justifyContent: "center" }}
        >
          <PaginationComponent
            currentPage={page}
            totalPages={totalPages}
            onPageChange={setPage}
            pageSize={pageSize}
            setPageSize={setPageSize}
          />
        </div>
      )}
    </div>
  );
};

export default Coupons;
